import { auth } from "../firebase";
import React, { useLayoutEffect, useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
} from "react-native";
import { Avatar } from "react-native-elements";
import ChatCard from "../components/ChatCard";

import { AntDesign, SimpleLineIcons } from "@expo/vector-icons";

import { db } from "../firebase";

export default function HomeScreen({ navigation }) {
  function logout() {
    auth.signOut().then(() => navigation.replace("Login"));
  }

  useLayoutEffect(() => {
    navigation.setOptions({
      title: "Signal",
      headerStyle: { backgroundColor: "white" },
      headerTitleStyle: {
        color: "black",
      },
      headerTintColor: "black",
      headerLeft: () => {
        return (
          <View style={{ marginLeft: 20 }}>
            <TouchableOpacity onPress={logout}>
              <Avatar
                rounded
                source={{
                  uri: "https://i.pravatar.cc/150?img=60",
                }}
              />
            </TouchableOpacity>
          </View>
        );
      },
      headerRight: () => {
        return (
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: 80,
              marginRight: 20,
            }}
          >
            <TouchableOpacity>
              <AntDesign name="camerao" size={24} color="black" />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => navigation.navigate("AddChat")}>
              <SimpleLineIcons name="pencil" size={22} color="black" />
            </TouchableOpacity>
          </View>
        );
      },
    });
  }, []);

  const [chats, set_chats] = useState([]);

  useEffect(() => {
    const unsubscribe = db.collection("chats").onSnapshot((snapshot) =>
      set_chats(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      )
    );

    return unsubscribe;
  }, []);

  const chat_screen = (id, chat_name) => {
    navigation.navigate("Chat", {
      id,
      chat_name,
    });
  };

  return (
    <SafeAreaView>
      <ScrollView>
        {chats.map((chat) => (
          <ChatCard chat={chat} key={chat.id} chat_screen={chat_screen} />
        ))}
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    height: "100%",
  },
});
